export default __webpack_public_path__ + "static/media-char-ef33f35a58a5a3f446f5ac2688a630a1.png";